module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DB79_1SB_HIT.db77c4b0.jpg";